document.addEventListener('DOMContentLoaded', function () {
    const maut1Wrapper = document.querySelector('.js-maut1Fields');
    if (!maut1Wrapper) return;

    const premiumFields = maut1Wrapper.querySelector('.js-maut1PremiumFields');
    const camperFields = maut1Wrapper.querySelector('.js-maut1CamperFields');
    const boxTypeHidden = maut1Wrapper.querySelector('#maut1_boxtype');
    const colorOptions = maut1Wrapper.querySelectorAll('.js-maut1ColorOption');

    // --- Variation map for boxtype sync ---
    let variationMap = {};
    const mapData = document.getElementById('maut1-variation-map');
    if (mapData) {
        try {
            variationMap = JSON.parse(mapData.textContent);
        } catch (e) { /* ignore */ }
    }

    function syncRequiredAttributes() {
        [premiumFields, camperFields].forEach(function (container) {
            if (!container) return;
            var isVisible = container.style.display !== 'none';
            var fields = container.querySelectorAll('select, input:not([type="hidden"])');
            fields.forEach(function (field) {
                if (isVisible) {
                    field.setAttribute('required', 'required');
                    field.disabled = false;
                    if (field.dataset.wasRequired === '1') {
                        field.classList.add('js-requiredField');
                    }
                } else {
                    if (field.classList.contains('js-requiredField')) {
                        field.dataset.wasRequired = '1';
                    }
                    field.removeAttribute('required');
                    field.disabled = true;
                    field.classList.remove('js-requiredField');
                }
            });
        });
    }

    function syncBoxFields() {
        let boxtype = 'standard';

        const variationIdInput = document.querySelector('input[name="variation_id"]');
        if (variationIdInput && variationIdInput.value) {
            const varId = parseInt(variationIdInput.value, 10);
            if (varId > 0 && variationMap[varId]) {
                boxtype = variationMap[varId].toLowerCase();
            }
        }

        if (boxtype === 'standard') {
            const attrSelect = document.querySelector('select[name="attribute_soort-tolbadge"], select[name*="soort-tolbadge"], select[name*="attribute_"]');
            if (attrSelect && attrSelect.value) {
                const attrValue = attrSelect.value.toLowerCase();
                if (attrValue.includes('premium')) {
                    boxtype = 'premium';
                } else if (attrValue.includes('camper') || attrValue.includes('> 3 meter') || attrValue.includes('>3 meter')) {
                    boxtype = 'camper';
                }
            }
        }

        const fallbackSelect = maut1Wrapper.querySelector('select[name="maut1_boxtype"]');
        if (boxtype === 'standard' && fallbackSelect) {
            boxtype = (fallbackSelect.value || 'standard').toLowerCase();
        }

        if (boxTypeHidden) {
            boxTypeHidden.value = boxtype || 'standard';
        }

        if (premiumFields) {
            premiumFields.style.display = boxtype === 'premium' ? '' : 'none';
        }
        if (camperFields) {
            camperFields.style.display = boxtype === 'camper' ? '' : 'none';
        }

        syncRequiredAttributes();
    }

    // --- WooCommerce variation events (jQuery) ---
    if (typeof jQuery !== 'undefined') {
        jQuery(function ($) {
            $(document.body).on('found_variation', function () {
                setTimeout(syncBoxFields, 100);
            });
            $(document.body).on('reset_data', function () {
                setTimeout(syncBoxFields, 100);
            });
            $(document.body).on('update_variation_values', syncBoxFields);
            $(document.body).on('change', '.variations select, .variations input[type="radio"], select[name^="attribute_"]', function () {
                syncBoxFields();
                setTimeout(syncBoxFields, 500);
            });
            $(document.body).on('change', 'input[name="variation_id"]', syncBoxFields);
            $(document.body).on('updated_wc_div', syncBoxFields);
            $(document.body).on('woocommerce_variations_loaded', syncBoxFields);
        });
    }

    // --- Color selector ---
    var colorValueField = maut1Wrapper.querySelector('.js-maut1ColorValue');

    function syncColorValue() {
        var checked = maut1Wrapper.querySelector('input[name="maut1_color_radio"]:checked');
        if (colorValueField) {
            colorValueField.value = checked ? checked.value : '';
        }
        colorOptions.forEach(function (opt) { opt.classList.remove('-error'); });
    }

    if (colorOptions.length > 0) {
        colorOptions.forEach(function (option) {
            option.addEventListener('click', function (e) {
                if (e.target.tagName === 'INPUT') return;
                var radio = option.querySelector('input[type="radio"]');
                if (radio) {
                    colorOptions.forEach(function (opt) {
                        opt.classList.remove('-selected');
                        opt.classList.remove('-error');
                        opt.querySelector('input[type="radio"]').checked = false;
                    });
                    option.classList.add('-selected');
                    radio.checked = true;
                    syncColorValue();
                }
            });
        });

        maut1Wrapper.querySelectorAll('input[name="maut1_color_radio"]').forEach(function (radio) {
            radio.addEventListener('change', function () {
                colorOptions.forEach(function (opt) { opt.classList.remove('-selected'); });
                if (radio.checked) {
                    var parent = radio.closest('.js-maut1ColorOption');
                    if (parent) parent.classList.add('-selected');
                }
                syncColorValue();
            });
        });
    }

    // --- Fallback boxtype select ---
    const fallbackSelect = maut1Wrapper.querySelector('select[name="maut1_boxtype"]');
    if (fallbackSelect) {
        fallbackSelect.addEventListener('change', syncBoxFields);
    }

    // --- Form submit guard ---
    if (typeof jQuery !== 'undefined') {
        jQuery(function ($) {
            $(document).on('click', 'form.cart button[type="submit"], .single_add_to_cart_button', function (e) {
                syncBoxFields();
                syncRequiredAttributes();
                if (boxTypeHidden && !boxTypeHidden.value) {
                    boxTypeHidden.value = 'standard';
                }

                syncColorValue();
            });

            $('form.cart').on('submit', function (e) {
                syncBoxFields();
                syncRequiredAttributes();
                if (boxTypeHidden && !boxTypeHidden.value) {
                    boxTypeHidden.value = 'standard';
                }
                syncColorValue();
            });
        });
    }

    // --- Prevent Enter key submit in text fields ---
    if (typeof jQuery !== 'undefined') {
        jQuery(function ($) {
            $(document.body).on('keydown', 'form.cart input[type="text"], form.cart textarea', function (e) {
                if ((e.key === 'Enter' || e.keyCode === 13) && this.type !== 'submit' && this.type !== 'button') {
                    e.preventDefault();
                    return false;
                }
            });
        });
    }

    // Reset Maut1 color & boxtype state after a successful single-product
    // add-to-cart so the form is clean for the next order.
    if (typeof jQuery !== 'undefined') {
        jQuery(document.body).on('added_to_cart', function (event, fragments, hash, $button) {
            if (!$button || !$button.length) return;
            if (!$button[0].classList.contains('single_add_to_cart_button')) return;

            if (colorOptions && colorOptions.length > 0) {
                colorOptions.forEach(function (opt) {
                    opt.classList.remove('-selected');
                    opt.classList.remove('-error');
                });
                maut1Wrapper.querySelectorAll('input[name="maut1_color_radio"]').forEach(function (radio) {
                    radio.checked = false;
                });
                if (colorValueField) {
                    colorValueField.value = '';
                }
            }

            setTimeout(syncBoxFields, 100);
        });
    }

    // --- Initial sync ---
    syncBoxFields();
    setTimeout(syncBoxFields, 200);
    setTimeout(syncBoxFields, 1000);
});
